// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MobileApplicationSection_mobile-application__YOfYR {
  margin-top: 8.5rem;
  max-width: 134rem;
  margin-inline: auto;
  padding: 4.9rem 0 11.4rem 9rem;
  position: relative;
}

.MobileApplicationSection_mobile-application__about__EM\\+sh {
  border-radius: 3rem;
  background-color: var(--sky-36-opacity);
  padding: 5.3rem 3rem 2.8rem;
  position: relative;
}

.MobileApplicationSection_mobile-application__content__dqWZj {
  max-width: 50%;
}

.MobileApplicationSection_mobile-application__mtor-vector__Fk6HY {
  position: absolute;
  top: 50%;
  bottom: 50%;
  transform: translateY(-50%);
  right: 0;
}

.MobileApplicationSection_mobile-application__download-text__M\\+e8M {
  font-size: var(--text-base);
  font-weight: 700;
  line-height: 2.2rem;
  color: var(--primary-color);
  margin-block: 1.7rem 2.5rem;
}

.MobileApplicationSection_mobile-application__header__ALVxO {
  font-size: var(--text-4xl);
  font-weight: 700;
  line-height: 6rem;
  color: var(--black-extra-light);
  margin-bottom: 2rem;
}

.MobileApplicationSection_mobile-application__fire__PWb7H {
  display: inline-block;
  margin-inline-start: 2rem;
}

.MobileApplicationSection_mobile-application__text__6uE-7 {
  font-size: var(--text-base);
  font-weight: 500;
  color: var(--black-extra-light);
  margin-bottom: 2rem;
}

.MobileApplicationSection_mobile-application__links__SOILj {
  display: flex;
  gap: 5rem;
  align-items: center;
  margin-bottom: 2.8rem;
}

.MobileApplicationSection_mobile-application__qr-code__k7Eiu {
  padding: 1.2rem;
  background-color: #fff;
  border-radius: 10px;
}

.MobileApplicationSection_mobile-application__store-link__Cq\\+fw {
  display: block;
  width: 16rem;
  height: 5rem;
}

.MobileApplicationSection_mobile-application__store-link__Cq\\+fw:first-child {
  margin-bottom: 1rem;
}

.MobileApplicationSection_mobile-application__mockup__3PzIb {
  object-fit: contain;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  max-width: 50%;
  max-height: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/components/Home/MobileApplicationSection/MobileApplicationSection.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,QAAQ;AACV;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,gBAAgB;AAClB","sourcesContent":[".mobile-application {\n  margin-top: 8.5rem;\n  max-width: 134rem;\n  margin-inline: auto;\n  padding: 4.9rem 0 11.4rem 9rem;\n  position: relative;\n}\n\n.mobile-application__about {\n  border-radius: 3rem;\n  background-color: var(--sky-36-opacity);\n  padding: 5.3rem 3rem 2.8rem;\n  position: relative;\n}\n\n.mobile-application__content {\n  max-width: 50%;\n}\n\n.mobile-application__mtor-vector {\n  position: absolute;\n  top: 50%;\n  bottom: 50%;\n  transform: translateY(-50%);\n  right: 0;\n}\n\n.mobile-application__download-text {\n  font-size: var(--text-base);\n  font-weight: 700;\n  line-height: 2.2rem;\n  color: var(--primary-color);\n  margin-block: 1.7rem 2.5rem;\n}\n\n.mobile-application__header {\n  font-size: var(--text-4xl);\n  font-weight: 700;\n  line-height: 6rem;\n  color: var(--black-extra-light);\n  margin-bottom: 2rem;\n}\n\n.mobile-application__fire {\n  display: inline-block;\n  margin-inline-start: 2rem;\n}\n\n.mobile-application__text {\n  font-size: var(--text-base);\n  font-weight: 500;\n  color: var(--black-extra-light);\n  margin-bottom: 2rem;\n}\n\n.mobile-application__links {\n  display: flex;\n  gap: 5rem;\n  align-items: center;\n  margin-bottom: 2.8rem;\n}\n\n.mobile-application__qr-code {\n  padding: 1.2rem;\n  background-color: #fff;\n  border-radius: 10px;\n}\n\n.mobile-application__store-link {\n  display: block;\n  width: 16rem;\n  height: 5rem;\n}\n\n.mobile-application__store-link:first-child {\n  margin-bottom: 1rem;\n}\n\n.mobile-application__mockup {\n  object-fit: contain;\n  position: absolute;\n  left: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  max-width: 50%;\n  max-height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mobile-application": `MobileApplicationSection_mobile-application__YOfYR`,
	"mobile-application__about": `MobileApplicationSection_mobile-application__about__EM+sh`,
	"mobile-application__content": `MobileApplicationSection_mobile-application__content__dqWZj`,
	"mobile-application__mtor-vector": `MobileApplicationSection_mobile-application__mtor-vector__Fk6HY`,
	"mobile-application__download-text": `MobileApplicationSection_mobile-application__download-text__M+e8M`,
	"mobile-application__header": `MobileApplicationSection_mobile-application__header__ALVxO`,
	"mobile-application__fire": `MobileApplicationSection_mobile-application__fire__PWb7H`,
	"mobile-application__text": `MobileApplicationSection_mobile-application__text__6uE-7`,
	"mobile-application__links": `MobileApplicationSection_mobile-application__links__SOILj`,
	"mobile-application__qr-code": `MobileApplicationSection_mobile-application__qr-code__k7Eiu`,
	"mobile-application__store-link": `MobileApplicationSection_mobile-application__store-link__Cq+fw`,
	"mobile-application__mockup": `MobileApplicationSection_mobile-application__mockup__3PzIb`
};
export default ___CSS_LOADER_EXPORT___;
